<template lang="pug">
component.button(:is="componentTyoe", v-bind="linkAttributes", @click="clickEvent")
  .button__text
    slot
</template>

<script>
export default {
  name: "MainButton",
  props: {
    link: {
      type: String,
      default: "",
    },
    isTargetBlank: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentTyoe() {
      return this.link ? "a" : "button";
    },
    linkAttributes() {
      return this.link
        ? {
          href: this.link,
          target: this.isTargetBlank ? "_blank" : "_self",
        }
        : {};
    },
  },
  methods: {
    clickEvent(event) {
      if (!this.link) {
        this.$emit("click", event);
      }
    },
  },
};
</script>
